function getStateAfterSubmission(state, action) {
	return state.merge({
		isSubmittedByQuarterNum: {
			...state.isSubmittedByQuarterNum,
			[action.quarterNum]: action.isSubmitted
		}
	}, { deep: true });
}

function getStateAfterFinancialRatiosSubmission(state, action) {
	return state.merge({
		isFinancialRatiosSubmittedForLastQuarter: action.isSubmitted
	}, { deep: true });
}

export {
	getStateAfterSubmission,
	getStateAfterFinancialRatiosSubmission
};
